export enum QuestionType {
  Calculation = 'CALCULATION',
  Proof = 'PROOF',
  ShortAnswer = 'SHORT ANSWER',
  ExtendedResponse = 'EXTENDED RESPONSE',
  MultipleChoice = 'MULTIPLE CHOICE',
  Graphing = 'GRAPHING',
}

export enum QuestionGuideType {
  ExemplarAnswer = 'exemplarAnswer',
  MarkersNotes = 'markersNotes',
  MinimumAnswer = 'minimumAnswer',
  AnswersCouldInclude = 'answersCouldInclude',
}

export enum QuestionGuideLabel {
  ExemplarAnswer = 'Exemplar Answer',
  MarkersNotes = "Marker's Notes",
  MinimumAnswer = 'Minimum Answer',
  AnswersCouldInclude = 'Answers Could Include',
}
